// PURPOSE: Explain and confirm an explicit request for outreach drafts.
// CONTRACT: Spec 066; opening or cancelling never requests drafts.
// DEPENDS: The shared accessible Dialog component.
// CEILING: Confirmation only; the caller performs the authorized action.
import { Dialog } from './components';

export function DraftRequestConfirm({ count, onConfirm, onClose }: { count: number; onConfirm(): void; onClose(): void }) {
  return <Dialog title="Request drafts" onClose={onClose}>
    <p>Request drafts for {count} leads? Nothing is sent. Your AI will create Gmail drafts for you to review.</p>
    <div className="form-footer"><button className="button secondary" onClick={onClose}>Cancel</button><button className="button primary" onClick={onConfirm}>Request drafts</button></div>
  </Dialog>;
}
